import type { Messages } from '../messages.js'

/** Spanish. `giros` for flips, which is what a tile does and what the meter counts. */
export const es: Messages = {
  tag: 'es',

  readingDictionary: 'Leyendo el diccionario…',
  noWordList: 'No hay lista de palabras para «{language}». Genérala:  pnpm dictionary build',
  emptyWordList: 'La lista de palabras para «{language}» está vacía.',

  flips: 'giros',
  score: 'puntos',
  words: 'palabras',
  round: 'ronda',
  ticksLeftLabel: 'Tiempo restante en la ronda',
  typeAWord: 'escribe una palabra',
  tapPrompt: 'toca para elegir o soltar, luego {action}',

  boardOfTiles: 'Tablero de {n} fichas',
  faceDown: 'boca abajo',
  wildCard: 'comodín',
  wildKey: 'cualquier letra',
  letterReplaced: '{from} pasó a ser {to}',
  letterSwap: '¡CAMBIO DE LETRA!',
  spentTile: 'ficha gastada',
  hiddenWhilePaused: 'oculta en pausa',
  letterInWord: '{letter}, letra {position} de la palabra',

  completeWord: 'Completar palabra',

  completeShort: 'Completar',
  reset: 'Borrar',
  pause: 'Pausa',
  resume: 'Continuar',
  newGame: 'Nueva partida',
  paused: 'En pausa',
  outOfFlips: 'Sin giros',
  finalResult: '{score} puntos con {words} en {rounds}',
  playAgain: 'Jugar otra vez',
  share: 'Compartir',
  shareCopied: 'Copiado.',
  shareSelect: 'Copia esto:',

  lettersSelect: 'las letras seleccionan',
  keysWild: 'se toma al escribir una letra que ninguna ficha muestra',
  clearsEvery: 'quita todas las {letter} seleccionadas',
  undoLastLetter: 'deshace la última letra',
  noWordsYet: 'Todavía ninguna palabra.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'ya encontrada',
  reasonTooShort: 'demasiado corta',
  reasonNotAWord: 'no es una palabra',
  reasonAllFound: 'ya los tienes todos',
  noSuchLetterUp: 'ninguna {letter} descubierta',
  nothingUp: 'nada descubierto',
  letterHidden: 'una letra se ocultó',
  shuffled: 'mezclado',
  shuffledAndBilled: 'mezclado, {flips} giros sin usar cobrados',
  tooFewLetters: 'Quedan muy pocas letras',

  gameLanguage: 'idioma',
  interfaceLanguage: 'interfaz',
  dictionarySize: '{common} comunes de {full} palabras',
  filterLanguages: 'Buscar idiomas',
  noMatches: 'Sin resultados',

  nerdMode: 'modo detallado',
  rules: 'Reglas',
  difficulty: 'dificultad',
  difficultyNames: { easy: 'fácil', medium: 'medio', hard: 'difícil', insane: 'brutal' },
  pausedNoBoard: 'Esta partida no aparecerá en la clasificación.',
  about: 'Acerca de',
  themeLabel: 'tema',
  themeNames: { traditional: 'tradicional', light: 'claro', contrast: 'alto contraste' },
  tiles: 'fichas (N)',
  secondsPerTick: 'segundos / tiempo',
  holdTicks: 'tiempos de espera',
  minWord: 'palabra mínima',
  startingFlips: 'giros iniciales',
  wildChance: 'probabilidad de comodín',
  replaceChance: 'probabilidad de cambio de letra',
  hideChance: 'probabilidad de ocultar letra',
  wordCompleteMode: 'palabra completada',
  wordCompleteNames: { shuffle: 'mezclar', spend: 'gastar', keep: 'conservar' },
  flipEconomy: 'economía de giros',
  flipEconomyNames: {
    none: 'ninguna',
    perLetter: 'por letra',
    fibonacci: 'fibonacci',
    overMinimum: 'sobre el mínimo',
  },
  repeatedLetterKey: 'tecla de letra repetida',
  keySchemeNames: { cycle: 'ciclar', advance: 'avanzar' },
  keySchemeHelp: {
    cycle:
      'A toma la siguiente A libre y, cuando ya están todas en la palabra, las quita. ' +
      'Mayús+A también las quita.',
    advance: 'A toma la siguiente A libre. Mayús+A quita todas las A de la palabra.',
  },

  whatThatMeans: 'Qué significa eso',
  factRound: 'una ronda',
  factWholeBoardUp: 'tablero entero visible',
  factRoundCosts: 'una ronda cuesta',
  factFlipsBuy: 'los giros iniciales dan',
  factThisBoard: 'este tablero',
  factBoardHadToAdmit: 'el tablero debía admitir',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, la más larga {longest}',
  wordsIncludingOneOf: '{words} incluida una de {ceiling}',
  scorelessRounds: '{rounds} sin puntuar',

  whatAWordPays: 'Lo que paga una palabra',
  columnLetters: 'letras',
  columnCost: 'coste',
  columnPoints: 'puntos',
  columnFlips: 'giros',
  columnNet: 'neto',

  canonicalRules: 'Reglas {difficulty} oficiales.',
  customRules: 'Cambiado del preajuste. Las puntuaciones con reglas propias no se clasifican.',
  applyAndStart: 'Aplicar y empezar una partida',
  changesNextGame: 'Los cambios se aplican en la próxima partida.',
  presets: 'Preajustes:',

  start: 'Empezar',
  restart: 'Reiniciar',
  quit: 'Salir',
  quitTitle: '¿Salir de esta partida?',
  restartTitle: '¿Reiniciar esta partida?',
  restartConfirm: 'Reiniciar',
  quitConfirm: 'Salir',
  keepPlaying: 'Seguir jugando',
  personalBest: 'Tus mejores partidas',
  newPersonalBest: 'Nuevo récord personal.',
  columnRank: '#',
  notRanked: 'Reglas propias: esta partida no se clasifica.',
  notRankedPaused: 'El reloj se detuvo: esta partida no se clasifica.',
  rankOfTotal: '{rank} de {total}',

  howToPlay: 'Cómo jugar',

  backToGame: 'Volver al juego',
  welcomeTitle: 'Te damos la bienvenida a Blinkered',
  tutorialSkip: 'Saltar',
  tutorialNext: 'Siguiente',
  tutorialBack: 'Atrás',
  tutorialStart: 'Empezar a jugar',
  tutorialHideAgain: 'No volver a mostrar',
  tutorialProgress: '{n} de {total}',
  tutorialSkipTitle: '¿Saltar la introducción?',
  tutGoalTitle: 'Blinkered es una carrera',
  tutGoalBody:
    'Empiezas la partida con un número fijo de giros, y cada ficha que gira cuesta un giro. Cuando se acaban los giros, la partida termina. Formar palabras da giros, y cuanto más larga es la palabra, más giros ganas.',
  tutSpentBody:
    'Las letras que usas en una palabra quedan boca abajo hasta la ronda siguiente. Solo un cambio de letra altera qué letras hay en el tablero.',
  tutChangeTitle: 'Las letras pueden cambiar',
  tutSameLetters:
    '¿Has visto una palabra que no te dio tiempo a jugar? Las mismas letras vuelven en la ronda siguiente, mezcladas en otros sitios.',
  tutPickLetters: 'Toca las letras que quieras, en orden, para formar una palabra.',
  tutMoreTurn:
    'Las fichas siguen girándose mientras piensas, así que aún puede llegar una letra mejor.',
  tutTapBack:
    '¿Has tocado una que no querías? Tócala otra vez para devolverla. Cualquiera, no solo la última.',
  tutComplete: 'Pulsa Completar cuando la palabra esté lista.',
  htBoardTitle: 'El tablero',
  htBoardBody:
    'Las fichas se descubren una a una, en un orden aleatorio. Las fichas descubiertas sirven para formar palabras.',
  htWordsTitle: 'Las palabras',
  htWordsBody:
    'Forma una palabra con las fichas descubiertas, escribiendo o pulsando las letras en orden.',
  htFlipsTitle: 'Los giros',
  htFlipsBody:
    'Cada ficha que gira cuesta un giro. Una palabra completada suma giros a tu total, y las palabras largas dan más. Cuando se acaban los giros, la partida termina.',
  htRoundTitle: 'La ronda',
  htRoundBody:
    'Cuando gira la última ficha de una ronda, el tablero entero se queda a la vista un momento. Después las fichas se giran boca abajo y se mezclan, y empieza una ronda nueva.',
  htLanguagesTitle: 'Los idiomas',
  htLanguagesBody:
    '{n}. Cada tablero se puede resolver con palabras de uso real. Una palabra poco común también puntúa, si el diccionario la conoce.',
  htKeysTitle: 'El teclado',
  htWildTitle: 'Los comodines',
  htWildBody:
    'A veces aparece un comodín en lugar de una letra. Un comodín vale cualquier letra que forme una palabra válida. Una palabra ya completada no cuenta.',
  htHideTitle: 'Letras que se ocultan',
  htHideBody:
    'En los niveles más difíciles una letra descubierta puede volver a girarse sola y regresar más tarde en la ronda. El temporizador gana un tic por ello, en rojo. Las letras que ya has elegido no se giran.',
  tutHideBody:
    'En los niveles más difíciles una letra descubierta puede volver a girarse sola y regresar más tarde en la ronda. Las letras que ya has elegido no se giran.',
  htSwapTitle: 'Las letras cambian',
  htSwapBody:
    'A veces, entre rondas, una letra se sustituye por otra. Verás qué letra se ha quitado y cuál se ha añadido.',
  htLevelsTitle: 'Los niveles',
  htLevelEasy:
    'Las mismas doce letras durante toda la partida: puedes aprendértelas y llevar una lista de palabras en la cabeza. Las fichas se giran despacio y el tablero completo se queda a la vista el tiempo suficiente para terminar de elegir tus letras.',
  htLevelMedium:
    'Una letra cambia de vez en cuando, así que cuesta más recordar las palabras que querías jugar más adelante. Menos tiempo para mirar y menos para pensar.',
  htLevelHard:
    'Las palabras de tres letras dejan de contar y una letra cambia más o menos cada dos rondas. El tablero apenas se ve antes de barajarse.',
  htLevelInsane:
    'Todo a la vez y a toda velocidad. El tablero se mezcla casi justo después del último giro.',
  htTouchTitle: 'La pantalla táctil',
  htTouchBody:
    'Toca una ficha destapada para tomar su letra. Toca cualquier letra ya tomada para soltarla. Completar y Borrar están debajo del tablero.',

  accountTitle: 'Tu cuenta',
  menuProfile: 'Mi perfil',
  menuGames: 'Mis partidas',
  menuPublicPage: 'Mi página pública',
  menuSignedInAs: 'Sesión iniciada como',
  signIn: 'Iniciar sesión',
  signOut: 'Cerrar sesión',
  signInTitle: 'Inicia sesión o regístrate',
  signInLead: 'Una cuenta guarda tus partidas, en todos tus dispositivos.',
  signInKeepGame: 'Inicia sesión para guardar esta partida, y todas las siguientes.',
  continueWithApple: 'Continuar con Apple',
  continueWithGoogle: 'Continuar con Google',
  signInOr: 'o',
  emailLabel: 'Correo',
  codeLabel: 'Código',
  emailMeACode: 'Envíame un código',
  working: 'Un momento…',
  sendNewCode: 'Enviar un código nuevo',
  codeSent: 'Mira tu correo. El código dura 10 minutos.',
  notNow: 'Ahora no',
  badEmail: 'Eso no parece una dirección de correo.',
  badCode: 'Ese código no funcionó. Los códigos caducan a los 10 minutos y solo sirven una vez.',
  serverBusy: 'No se pudo contactar con el servidor. Inténtalo en un momento.',
  serverDown: 'No se pudo contactar con el servidor.',
  offline: 'Sin conexión',
  leaderboardTitle: 'Clasificación',
  leaderboardEmpty: 'Todavía no hay partidas en esta clasificación. Sé el primero.',
  leaderboardWouldBe: 'Dónde quedaría esta partida',
  leaderboardThisGame: 'Esta partida',
  leaderboardRanksHere: 'Dónde queda esta partida',
  leaderboardOutside: 'Fuera de los cinco primeros.',
  tutAccountTitle: 'Guarda tus puntuaciones',
  tutAccountBody:
    'Una cuenta guarda tus partidas, pone tus puntuaciones en la clasificación y mantiene tu perfil.',
  ssoCancelled: 'Se canceló el inicio de sesión.',
  ssoExpired: 'Tardó demasiado. Vuelve a iniciar sesión.',
  ssoNoUsername: 'No se pudo terminar de crear la cuenta. Inténtalo en un momento.',
  ssoFailed: 'No funcionó. Inténtalo de nuevo o usa tu correo.',
  tabProfile: 'Perfil',
  countryAny: 'Prefiero no decirlo',
  findCountry: 'Buscar países',
  usernameLabel: 'Nombre de usuario',
  bioLabel: 'Biografía',
  countryLabel: 'País',
  bioHint: 'Sin enlaces. {left}/{max}',
  save: 'Guardar',
  saving: 'Guardando…',
  saved: 'Guardado.',
  nameTaken: 'Ese nombre ya lo tiene alguien.',
  nameTooShort: 'Un poco más largo, por favor.',
  nameTooLong: 'Es demasiado largo.',
  nameBadCharacters: 'Solo letras, números, guiones y guiones bajos.',
  nameBadEdges: 'Tiene que empezar y terminar con una letra o un número.',
  nameMixedScripts: 'Elige un solo alfabeto y quédate en él.',
  nameReserved: 'Ese se parece a un nombre que damos nosotros. Elige otro.',
  nameUnusable: 'Ese nombre no se puede usar.',
  bioTooLong: 'Las biografías tienen como máximo {max} caracteres.',
  bioHasLink: 'No se permiten enlaces en la biografía.',
  bioHasControl: 'Contiene caracteres que una biografía no admite.',
  bioUnusable: 'Esa biografía no se puede usar.',
  gamesHeading: 'Partidas',
  gamesEmpty:
    'Aquí todavía no hay nada. Las partidas que juegues con la sesión iniciada aparecerán aquí.',
  gamesEmptyShort: 'Aquí todavía no hay nada.',
  gamesLoading: 'Leyendo tus partidas…',
  theirGamesLoading: 'Leyendo sus partidas…',
  profileLoading: 'Leyendo el perfil…',
  playerNotFound: 'Aquí no hay nadie con ese nombre.',
  columnWhen: 'Cuándo',
  columnRounds: 'rondas',
  columnGame: 'Partida',
  gameLoading: 'Leyendo la partida…',
  gameUnreadable: 'No se pudo leer esta partida.',
  gameNotRanked: 'Jugada con reglas modificadas, así que no puntúa.',
  detailNotKept: 'Las palabras y los tableros de esta partida ya no se guardan.',
  openingBoard: 'El tablero inicial',
  roundByRound: 'Ronda a ronda',
  roundNothing: 'nada encontrado',
  changeReplaced: '{letter} sustituida en la casilla {slot}',
  changeWildOn: '{letter} comodín en la casilla {slot}',
  changeWildOff: '{letter} comodín retirado de la casilla {slot}',
  keepThisGame: 'Guardar esta partida',
  savedToYourGames: 'Guardada en tus partidas.',

  reportThis: 'Denunciar',
  reportHeading: 'Denunciar esto',
  reportTheName: 'El nombre',
  reportTheBio: 'La biografía',
  reportTheScore: 'La puntuación',
  reportWhy: '¿Qué tiene de malo? Opcional.',
  reportSend: 'Enviar la denuncia',
  reportSent: 'Gracias. Alguien lo revisará.',
  reportSignIn: 'Inicia sesión para denunciar algo.',
  reportGone: 'Eso ya no está.',
  reportCancel: 'Cancelar',

  deleteAccount: 'Eliminar mi cuenta',
  deleteAccountWhat:
    'Esto elimina tu perfil y todas las partidas que has guardado, para siempre. No se puede deshacer.',
  deleteAccountAsk: 'Envíame un código',
  deleteConfirm: 'Eliminar para siempre',
  deleteGone: 'Tu cuenta ya no existe. Gracias por jugar.',
  deleteNoAddress:
    'No hay una dirección confirmada en esta cuenta, así que no se puede comprobar una eliminación. Escríbenos y lo haremos a mano.',

  rulesetFacts: 'Palabras de {letters} · una ficha nueva cada {seconds}',
  plurals: {
    words: { one: '{n} palabra', other: '{n} palabras' },
    rounds: { one: '{n} ronda', other: '{n} rondas' },
    flips: { one: '{n} giro', other: '{n} giros' },
    ticks: { one: '{n} tiempo', other: '{n} tiempos' },
    points: { one: '{n} punto', other: '{n} puntos' },
    minLetters: { one: '{n} letra o más', other: '{n} letras o más' },
    seconds: { one: '{n} segundo', other: '{n} segundos' },
  },
}
